import { render, staticRenderFns } from "./ComSettle.vue?vue&type=template&id=b49c3d32&scoped=true"
import script from "./ComSettle.vue?vue&type=script&lang=js"
export * from "./ComSettle.vue?vue&type=script&lang=js"
import style0 from "./ComSettle.vue?vue&type=style&index=0&id=b49c3d32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49c3d32",
  null
  
)

export default component.exports